import { primaryColor, fontColor } from '../../config/theme';

const style = {
	stackCard: {
		fontFamily: 'Poppins',
		textAlign: 'center',
		alignItems: 'center',
		justifyContent: 'center',
		marginTop: 10
	},
	stackCardChef: {
		fontFamily: 'Poppins',
		textAlign: 'center',
		alignItems: 'center',
		justifyContent: 'center',
		marginTop: 10,
		minHeight: 460
	},
	stackCardHeader: {
		fontFamily: 'Poppins',
		textAlign: 'center',
		alignItems: 'center',
		justifyContent: 'center',
		marginTop: 10
	},
	step: {
		color: fontColor,
		backgroundColor: primaryColor,
		margin: '5px 7px 10px',
		borderRadius: '50%',
		padding: '2px 12px'
	},
	step1: {
		color: fontColor,
		backgroundColor: primaryColor,
		margin: '5px 7px 10px',
		borderRadius: '50%',
		padding: '2px 15px'
	}
};

export default style;
